import hu from './locales/hu';
import rs from './locales/rs';

export default {
  hu,
  rs
};